import classes from './PhoneGroup.module.css'

const ExteriorGroup = ({ext}) => {
    return <div>
        <div className={classes.label}>Ext</div>
        <div className={classes.text}>{ext}</div>
    </div>
}

export default ExteriorGroup